// extracted by mini-css-extract-plugin
export default {"infoContainer":"Info-module__infoContainer___JIhaW"};